export default __webpack_public_path__ + "static/media/winner.8e165dae.svg";